<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <v-progress-circular
      v-if="loading"
      :size="100"
      :width="4"
      color="fmq_black"
      indeterminate
      class="d-flex mx-auto py-8 mt-8"
    ></v-progress-circular>
    <div v-else>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/notificacoes"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <NotificacaoFormulario
          @send="criar"
          :item="item"
          :listFuncionarios="listFuncionarios"
          :listForcaDeVendas="listForcaDeVendas"
          :loadingBtn="loadingBtn"
        />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Notificação criada com sucesso"
      @close="goTo"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { storeNotification } from "@/services/notification.js";
import NotificacaoFormulario from "@/components/notificacoes/NotificacaoFormulario.vue";
import { listEmployee } from "@/services/employee";
import { listSaleForce } from "@/services/sale-force";
export default {
  name: "NotificacaoCriar",
  components: { NotificacaoFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Notificações",
        disabled: false,
        to: "/notificacoes",
      },
      {
        text: "Criar Notificação",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
    item: {},
    loading: false,
    listFuncionarios: [],
    listForcaDeVendas: []
  }),
  created() {
    this.listarFuncionarios();
    this.listarForcaDeVendas();
  },
  methods: {
    async criar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await storeNotification(event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    goTo() {
      this.sucess = false;
      this.$router.push({ name: "Notificacoes" });
    },
    async listarFuncionarios() {
      const resp = await listEmployee();
      this.listFuncionarios = resp.data;
    },
    async listarForcaDeVendas() {
      const resp = await listSaleForce();
      this.listForcaDeVendas = resp.data;
    },
  },
};
</script>

<style></style>
